const SEARCH_KEYS = new Set([
  "q",
  "category",
  "city",
  "lat",
  "lng",
  "location_label",
  "radius_km",
  "facility_service",
  "open_now",
  "program_type",
  "skill_level",
  "spots_available",
  "specialization",
  "starts_after",
  "starts_before",
  "registration_open",
  "competition_type",
  "relationship",
  "member_only",
  "min_price",
  "max_price",
  "price_currency",
  "offset",
]);
const UNSAFE_URL_CHARACTERS = /[\\\u0000-\u001f\u007f]/;

export function validSearchReturn(
  value: string | null | undefined,
): value is string {
  if (
    !value ||
    value.length > 2048 ||
    UNSAFE_URL_CHARACTERS.test(value) ||
    !/^\/search(?:\?|$)/.test(value)
  )
    return false;
  try {
    const url = new URL(value, "https://player.invalid");
    if (url.pathname !== "/search" || url.hash) return false;
    const seen = new Set<string>();
    for (const [key, item] of url.searchParams) {
      if (
        !SEARCH_KEYS.has(key) ||
        seen.has(key) ||
        UNSAFE_URL_CHARACTERS.test(item)
      )
        return false;
      seen.add(key);
    }
    const hasCoordinate =
      url.searchParams.has("lat") || url.searchParams.has("lng");
    if (hasCoordinate) {
      const latitude = Number(url.searchParams.get("lat"));
      const longitude = Number(url.searchParams.get("lng"));
      if (
        !url.searchParams.get("location_label")?.trim() ||
        !url.searchParams.has("radius_km") ||
        url.searchParams.has("city") ||
        !Number.isFinite(latitude) ||
        latitude < -90 ||
        latitude > 90 ||
        !Number.isFinite(longitude) ||
        longitude < -180 ||
        longitude > 180
      )
        return false;
    }
    return true;
  } catch {
    return false;
  }
}

/** URL-carried context survives refresh and never accepts an external target. */
export function readSearchReturn(search: string): string | undefined {
  const values = new URLSearchParams(search).getAll("search_return");
  return values.length === 1 && validSearchReturn(values[0])
    ? values[0]
    : undefined;
}

export function withSearchReturn(path: string, returnTo?: string): string {
  if (
    !validSearchReturn(returnTo) ||
    !path.startsWith("/") ||
    path.startsWith("//") ||
    UNSAFE_URL_CHARACTERS.test(path)
  )
    return path;
  const target = new URL(path, "https://player.invalid");
  target.searchParams.set("search_return", returnTo);
  return target.pathname + target.search + target.hash;
}
